import '../../monitoring/charts/chart_view.js.coffee'

Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.ChartView extends Monitoring.Views.Charts.ChartView
  generic_chart_template: JST['backbone/templates/customer_visual_mode/charts/generic_chart']

  events:
    'click #close_chart': 'destroy'
    'click #save_note': 'saveNote'
    'click #delete_note': 'deleteNote'
    'click #sort_asc': 'sortAsc'
    'click #sort_desc': 'sortDesc'
    'click .insert-note': 'displayNote'

  initialize: ({widget, title, description = null, data, session, isReadOnly = false, isResponsive = false}) ->
    @title = title
    @description = description
    @data = data
    @session = session
    @isReadOnly = isReadOnly
    @isResponsive = isResponsive
    @widget = widget

  render: ->
    @$el.html @generic_chart_template
      title: @title
      description: @description
      isReadOnly: @isReadOnly
      isResponsive: @isResponsive
    @_renderTooltip()

  _renderTooltip: ->
    @$('.chart-title-content').tooltip
      placement: 'right'

  addNoteBox: ->
    @noteChart = new Monitoring.Views.Charts.NoteChartView(@chart_note_name())
    @$el.find('.chart-notes').append(@noteChart.render(@widget.get('note')).el)
    @displayNote() if @widget.get('note')

  afterAppend: ->
    @trigger('masonry')

  saveNote: =>
    newNote = @noteChart.getValue()
    if @widget.get('note') != newNote
      @widget.set('note', newNote)
      @widget.updateWidget(-> showSuccess(I18n.t('monitoring.dashboard.charts.save_success')))

  deleteNote: =>
    @noteChart.clearValue()
    if @widget.get('note') != ''
      @widget.set('note', '')
      @widget.updateWidget()
    @hideNote()

  destroy: ->
    id = @widget.get('id')
    @widget.destroy()
    @trigger('removed', id)
    @remove()

  sortAsc: ->
    @trigger('asc', @)

  sortDesc: ->
    @trigger('desc', @)

  _updateTitle: (newTitle = @_getTitle()) ->
    @title = newTitle
    @$('.chart-title-content')
      .text(@title)
      .prop('title', @title)

  _getTitle: ->
    name = @widget.get('widget_name')
    @widget.set('title', I18n.t("customer_visual_mode.charts.#{name}.title"))

  _openDrilldown: (data) =>
    return if @isReadOnly
    url = "#{@session.url()}/drilldowns/#{@_widgetName()}/?data=#{JSON.stringify(data)}"
    window.open(url, '_blank')

  _widgetName: ->
    @constructor.NAME

  onWidthChange: =>

  _workCalendarStrategy: (withWorkCalendarValue, withoutWorkCalendarValue) =>
    if !@widget || @widget.get('use_work_calendar') || @widget.get('use_work_calendar') == null
      withWorkCalendarValue
    else
      withoutWorkCalendarValue
